export const X_HEADER_SITEMODE = 'X-Stuller-Site-Mode'
